<script setup lang="ts">
import { computed } from 'vue'

// Бейдж очереди у пункта навигации владельца (owner_inbox). Вид — как счётчик
// колокольчика (NotificationBell.vue): одна форма «есть непрочитанное» на весь сайт.
// role="img" + aria-label: имя пункта читается как «Сегодня, в очереди: 2», а не
// «2 Сегодня», и «!» двери не озвучивается как «восклицательный знак».
const props = defineProps<{ label: string; floating?: boolean }>()
const spoken = computed(() => (props.label === '!' ? 'требует внимания' : `в очереди: ${props.label}`))
</script>

<template>
  <span data-testid="nav-badge" role="img" :aria-label="spoken"
        class="min-w-[1.1rem] rounded-full bg-crit-fill px-1 text-center text-xs leading-[1.1rem] font-semibold text-white tabular-nums"
        :class="floating ? 'absolute -right-2 -top-1' : 'inline-block'">{{ label }}</span>
</template>
